"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var colors = _interopRequireWildcard(require("../style/colors"));

var _Notification = require("./Notification.style");

var _index = require("../Icon/index");

var _info = _interopRequireDefault(require("../Icon/Icons/info"));

var _warning = _interopRequireDefault(require("../Icon/Icons/warning"));

var _checked = _interopRequireDefault(require("../Icon/Icons/checked"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var icons = {
  info: _react["default"].createElement(_info["default"], null),
  warning: _react["default"].createElement(_info["default"], {
    stroke: colors.yellow
  }),
  danger: _react["default"].createElement(_warning["default"], null),
  success: _react["default"].createElement(_checked["default"], null)
};

var Notification = function Notification(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      onClose = _ref.onClose,
      isVisible = _ref.isVisible,
      props = _objectWithoutProperties(_ref, ["title", "message", "type", "onClose", "isVisible"]);

  return _react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": isVisible,
    timeout: 150,
    classNames: "notification-fade",
    unmountOnExit: true
  }, _react["default"].createElement(_Notification.StyleBase, _extends({
    type: type
  }, props), icons[type], _react["default"].createElement(_Notification.StyledBody, null, _react["default"].createElement(_Notification.StyledTitle, null, title), _react["default"].createElement(_Notification.StyledMessage, null, message)), _react["default"].createElement(_Notification.StyledCloseBtn, {
    onClick: onClose
  }, _react["default"].createElement(_index.CloseIcon, null))));
};

Notification.propTypes = {
  type: _propTypes["default"].string,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  isVisible: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(['topLeft', 'topCenter', 'topRight', 'bottomRight', 'bottomCenter', 'bottomLeft'])
};
Notification.defaultProps = {
  position: 'bottomRight'
};
var _default = Notification;
exports["default"] = _default;